if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.bundleQuantity = this.dataset.bundleQuantity ? parseInt(this.dataset.bundleQuantity) : null;
        
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this), true);
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        
        if (this.bundleQuantity) {
          const formData = new FormData(this.form);
          const bundleOption = formData.get('Bundle');
          if (bundleOption === 'Bundle') {
            evt.stopImmediatePropagation();
          }
        }
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        if (this.bundleQuantity) {
          const bundleOption = formData.get('Bundle');
          if (bundleOption === 'Bundle') {
            const currentQuantity = parseInt(formData.get('quantity')) || 1;
            const adjustedQuantity = currentQuantity * this.bundleQuantity;
            formData.set('quantity', adjustedQuantity);
          }
        }
        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            /* Free shipping */
            fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then(data => {
              const shippingCountdownSelector = document.querySelectorAll(".shipping-countdown p span");
              const cleanCartTotal = (data.items_subtotal_price) / 100;
              const shippingThreshold = parseInt(document.querySelector(".shipping-countdown .shipping-threshold").innerText);
              const emptyCart = document.querySelectorAll(".shipping-countdown .empty-cart");
              const progressCart = document.querySelectorAll(".shipping-countdown .progress-cart");
              const fullCart = document.querySelectorAll(".shipping-countdown .full-cart");
        
              if(cleanCartTotal > 0 && cleanCartTotal < shippingThreshold) {
                for (var i = 0; i < emptyCart.length; i++) {
                  emptyCart[i].style.display = "none";
                }
                for (var i = 0; i < fullCart.length; i++) {
                  fullCart[i].style.display = "none";
                }
                for (var i = 0; i < progressCart.length; i++) {
                  progressCart[i].style.display = "block";
                }
                for (var i = 0; i < shippingCountdownSelector.length; i++) {
                  shippingCountdownSelector[i].innerHTML = '$' + parseFloat(shippingThreshold - cleanCartTotal).toFixed(2);
                }
              } else if(cleanCartTotal >= shippingThreshold) {
                for (var i = 0; i < emptyCart.length; i++) {
                  emptyCart[i].style.display = "none";
                }
                for (var i = 0; i < progressCart.length; i++) {
                  progressCart[i].style.display = "none";
                }
                for (var i = 0; i < fullCart.length; i++) {
                  fullCart[i].style.display = "block";
                }
              } else if(cleanCartTotal == 0) {
                for (var i = 0; i < fullCart.length; i++) {
                  fullCart[i].style.display = "none";
                }
                for (var i = 0; i < progressCart.length; i++) {
                  progressCart[i].style.display = "none";
                }
                for (var i = 0; i < emptyCart.length; i++) {
                  emptyCart[i].style.display = "block";
                }
              }
              return data
            });

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
